import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import HeadSection from "./HeadSection";
import ShowCaseSection from "./ShowCaseSection";
import FeaturesSection from "./FeaturesSection";
import BannerSection from "./BannerSection";
import TestimonialSlider from "./TestimonialSlider";

function InvestorHome(props) {
  const { selectHome } = props;
  const [showSafariBanner, setShowSafariBanner] = useState(false);

  useEffect(() => {
    selectHome();
  }, [selectHome]);

  useEffect(() => {
    document.body.style.backgroundColor = "#fff";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);


  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Disable the Safari banner completely
    setShowSafariBanner(false);

    // Remove padding adjustment
    document.body.style.paddingTop = '';

    // Clean up the padding when the component unmounts
    return () => {
      document.body.style.paddingTop = '';
    };
  }, []);

  return (
    <Fragment>
      <Helmet>
        <meta name="description" content="Join us at Auralyze.ai as we pave the way for groundbreaking advancements. Interested in learning more? Let's connect!" />
      </Helmet>
      <style>{`
        #safari-banner {
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          color: #fff;
          background-color: #9461FF;
          text-align: center;
          padding: 15px 0;
          font-weight: 700;
          font-size: 1.2em;
          position: fixed;
          width: 100%;
          top: 0;
          left: 0;
          z-index: 1000;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
          display: ${showSafariBanner ? 'block' : 'none'};
        }
      `}</style>
      <div id="safari-banner" style={{ display: showSafariBanner ? 'block' : 'none' }}>
        <p> 👋 Heads up! Our platform isn't ready for Safari just yet. 🚧 For the best experience, please switch to Google Chrome. 🌟</p>
      </div>
      <HeadSection />
      <ShowCaseSection />
      <FeaturesSection />
      <BannerSection />
      <TestimonialSlider />
    </Fragment>
  );
}

InvestorHome.propTypes = {
  selectHome: PropTypes.func.isRequired,
};

export default InvestorHome;